import { createFileRoute } from '@tanstack/react-router';

// The list alone, with no kickword open
export const Route = createFileRoute('/_authenticated/kickwords/')({});
